import React from "react";
import { connect } from "dva";
import { component_tool, framework_tool, utils_tool } from "@/tool";
import { modelUtils } from "@/utils";

import { ShowSubject as ShowSubjectComponent } from '../../../components'
import moment from 'moment';
import { Row, Col, Spin } from 'antd'

const { WizContainer, WizReduxTemplate, ossFileUtils } = framework_tool;
const {
  WizCard,
  WizRow,
  WizCol,
  WizTypography,
  WizDataTable,
  WizTabs,
  WizIcon,
  WizButton
} = component_tool;
let { $$, checkStrLength } = utils_tool;

class Index extends WizContainer {
  componentName = "BankQuestionLook";

  constructor(props) {
    super(props);
    this.state = {
      selectedRows: [],
      record: props.record,
      subjectProps: {}
    };
  }

  static defaultProps = {
    _ok: this._ok,
    _cancel: this._cancel
  };

  _cancel = (data) => {
  }
  _componentDidMount() {

    this.doAction(
      {
        path: 'ReviewQuestion/bankQuestionInfo',
        payload: {
          key: 'bankQuestionInfoKey@' + this.state.record.id,
          apiParams: { id: this.state.record.id }
        }
      });
  }
  /**
   * modal框的确定按钮触发
   * 可以在里面增加关闭modal前的操作及校验
   */
  _ok = (data) => {
  };
  _onClick = () => {
  };

  _getValue(type, key) {
    const values = {
      types: {
        Single: 0,
        Multiple: 1,
        Judgement: 2,
        Completion: 3,
        Subjective: 4,
        Script: 5
      },
      difficultys: {
        low: 0,
        middle: 1,
        high: 2
      },
      //单选 Single, 多选 Multiple, 判断 Judgement, 填空 Completion, 主观 Subjective
      typesTitle: {
        Single: '单选题',
        Multiple: '多选题',
        Judgement: '判断题',
        Completion: '填空题',
        Subjective: '主观题',
        Script: '话术题'
      },
      types2: {
        0: 'Single',
        1: 'Multiple',
        2: 'Judgement',
        3: 'Completion',
        4: 'Subjective',
        5: 'Script',
      },
      difficultys2: {
        0: 'low',
        1: 'middle',
        2: 'high'
      },
    }
    return values[type][key]
  }

  _bankQuestionInfo(nextProps, nextState) {
    let bankQuestionInfo = nextProps['bankQuestionInfo'];
    let subjectProps = {}
    if (bankQuestionInfo && bankQuestionInfo['success']) {
      this.bankQuestionInfoData = bankQuestionInfo.data
      this.bankQuestionInfoData.type = this._getValue('types2', this.bankQuestionInfoData.type)
      this.bankQuestionInfoData.isStart = true
      //单选
      if (this.bankQuestionInfoData.type === 'Single') {
        this.bankQuestionInfoData.answer = String.fromCharCode(parseInt(this.bankQuestionInfoData.correct) + 65)
        //多选
      } else if (this.bankQuestionInfoData.type === 'Multiple') {
        this.bankQuestionInfoData.answer = this.bankQuestionInfoData.correct.split(",").map(p => String.fromCharCode(parseInt(p) + 65)).join("、")
        //判断
      } else if (this.bankQuestionInfoData.type === 'Judgement') {
        this.bankQuestionInfoData.answer = parseInt(this.bankQuestionInfoData.correct)
        //主观
      } else if (this.bankQuestionInfoData.type === 'Subjective') {
        this.bankQuestionInfoData.answer = this.bankQuestionInfoData.correct
        //话术
      } else if (this.bankQuestionInfoData.type === 'Script') {
        console.log( this.bankQuestionInfoData.correct,'Script')
        this.bankQuestionInfoData.answer = this.bankQuestionInfoData.correct
        //填空
      }else if (this.bankQuestionInfoData.type === 'Completion') {
        //this.bankQuestionInfoData.answer = this.bankQuestionInfoData.correct
        let i = 0

        let answerObj = JSON.parse(this.bankQuestionInfoData.correct)
        let answer = new Array();
        for (; ; i++) {
          if (answerObj[i] === undefined) {
            break;
          } else {
            answer[i] = new Array();
            for (let j = 0; j < answerObj[i].length; j++) {
              answer[i][j] = answerObj[i][j]
            }
          }
        }
        this.bankQuestionInfoData.answer = answer
      }
      this.bankQuestionInfoData.analysis = this.bankQuestionInfoData.answerAnalysis
    }
    subjectProps.title = '【' + this._getValue('typesTitle', this.bankQuestionInfoData.type) + '】' + this.bankQuestionInfoData.title
    if (this.bankQuestionInfoData.type === 'Judgement') {
      subjectProps.options = [
        { title: ' ⭕️ 对' },
        { title: ' ❌ 错' },
      ]
      subjectProps.answer = this.bankQuestionInfoData.correct === "0" ? '⭕️ 对' : ' ❌ 错'
    } else if (this.bankQuestionInfoData.type === 'Single' || this.bankQuestionInfoData.type === 'Multiple') {
      subjectProps.options = this.bankQuestionInfoData.options.map(p => {
        let options = {}
        options.title = String.fromCharCode(p.order + 64) + '、' + p.name
        options.imgUrl = p['img'] && getOssFilePath(
          p['img'] + "?process=image/resize,l_" + 300
          // { m: 'lfit', l: 300 }
        )
        return options
      })
      subjectProps.answer = this.bankQuestionInfoData.answer
    } else if (this.bankQuestionInfoData.type === 'Subjective') {
      subjectProps.answer = this.bankQuestionInfoData.answer
    } else if (this.bankQuestionInfoData.type === 'Script') {
      subjectProps.answer = this.bankQuestionInfoData.answer
      subjectProps.gainList=this.bankQuestionInfoData.gainList
      subjectProps.lossList=this.bankQuestionInfoData.lossList
      subjectProps.mateWay = this.bankQuestionInfoData.mateWay
      subjectProps.scoreRuleGain = this.bankQuestionInfoData.scoreRuleGain
    } else if (this.bankQuestionInfoData.type === 'Completion') {
      subjectProps.answer = this.bankQuestionInfoData.answer
    }

    //题干图片处理
    if (this.bankQuestionInfoData.img) {
      subjectProps.titleImage = {
        src: getOssFilePath(
          this.bankQuestionInfoData['img'] + "?process=image/resize,l_" + 300
          // { m: 'lfit', l: 300 }
        )
      }
    }

    if (this.bankQuestionInfoData.answerAnalysis) {
      subjectProps.analysis = this.bankQuestionInfoData.answerAnalysis
    }
    //subjectProps.answer= this.bankQuestionInfoData.correct,
    //subjectProps.analysis= this.bankQuestionInfoData.answerAnalysis
    console.log(subjectProps,'subjectProps')
    this.setState({
      subjectProps: subjectProps,
      type: this.bankQuestionInfoData.type,
      id: this.bankQuestionInfoData.id
    })
    return true
  }
  propsAndStateOnChange = {
    bankQuestionInfo: this._bankQuestionInfo.bind(this),
  };


  _render() {

    let { id, subjectProps, type } = this.state
    let { bankQuestionLoading } = this.props
    return (
      <Spin tip={'加载中'} spinning={bankQuestionLoading}>
        <div>
          <ShowSubjectComponent key={this.props.record.id} type={type} {...subjectProps} />
          <Row>
            <Col span={22} />
            <Col span={2}>
              <WizButton onClick={() => {
                this.props && this.props.changeModal(false)
              }}>关 闭</WizButton>
            </Col>
          </Row>
        </div>
      </Spin>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { ReviewQuestion: bankQuestion } = state;
  const bankQuestionInfo = modelUtils.getModelEntity(bankQuestion, "bankQuestionInfoKey@" + ownProps.record.id);
  const load = modelUtils.getLoadingState(state, ['ReviewQuestion'])
  const {ReviewQuestionLoading: bankQuestionLoading} = load
  //log.info('load',load)
  return {
    bankQuestionInfo,
    bankQuestionLoading,
    ...load
  };
};

const options = { withRef: true };

export default connect(mapStateToProps, null, null, options)(Index);
